import { render, staticRenderFns } from "./HistoryDetailSellerLayout.vue?vue&type=template&id=7315f143&scoped=true"
import script from "./HistoryDetailSellerLayout.vue?vue&type=script&lang=js"
export * from "./HistoryDetailSellerLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7315f143",
  null
  
)

export default component.exports